import React, { FC } from "react";
import { useIntl } from "react-intl";

import { TemplateCardModuleVariant } from "../../../cards/TemplateCard";
import { TemplateCardModuleViewProps } from "../../../cards/TemplateCard/variants/module";
import { withLoaderHOC, WithLoaderHOC } from "../../../../atoms/Loader";

const ModuleLinkHubVariant: FC<Props> = ({
  templateData,
  maxTemplateCount,
  onClickCallback,
}) => {
  const { formatMessage } = useIntl();
  const dataToDisplay = templateData.slice(0, maxTemplateCount);

  return (
    <div style={{ textAlign: "center" }}>
      {templateData.length === 0 && formatMessage({ id: "common.empty_list" })}
      {dataToDisplay.map(({ id, ...rest }) => (
        <TemplateCardModuleVariant
          {...rest}
          onClick={onClickCallback}
          key={id}
        />
      ))}
    </div>
  );
};

export type TemplateData = TemplateCardModuleViewProps & { id: number };

type Props = {
  templateData: TemplateData[];
  maxTemplateCount?: number;
  onClickCallback?: () => void;
};

export default withLoaderHOC(ModuleLinkHubVariant);
export type ControlledProps = WithLoaderHOC<Props>;
